// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-border[data-v-7bfc9282]{border-top:none!important;margin-top:0!important}", ""]);
// Exports
module.exports = exports;
